import React from 'react';
import PropTypes from 'prop-types';

export default class ToggleSwitch extends React.Component {
  static propTypes = {
    on: PropTypes.bool,
    name: PropTypes.string.isRequired,
    onValue: PropTypes.bool.isRequired,
    offValue: PropTypes.bool.isRequired,
    callback: PropTypes.func,
  };

  static defaultProps = {
    on: false,
    onValue: true,
    offValue: false,
  };

  getValue() {
    const checkbox = this.refs[this.props.name];
    return checkbox && (checkbox.checked ? this.props.onValue : this.props.offValue);
  }

  update = () => {
    this.value = this.getValue();
    if (this.props.callback) {
      this.props.callback(this.value);
    }
  }

  render() {
    const id = `toggle-switch-${this.props.name}`;
    return (
      <div className='toggle-switch-export'>
        <input
          type='checkbox'
          name={this.props.name}
          defaultValue={this.props.on ? this.props.onValue : this.props.offValue}
          className='toggle-switch-export-checkbox'
          id={id}
          onChange={this.update}
          checked={this.props.on}
          ref={this.props.name}
        />
        <label className='toggle-switch-export-label' htmlFor={id} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/DataExports/components/ExportsSearch/children/CompileDataForm/children/AirlineSelections/children/children/ToggleSwitch.js